import { Section } from "../survey";
import type { ValidationResult } from "./distroValidator";

/**
 * Checks for duplicate Section `title.en` values.
 * Uses state to check for duplicates across all Sections, regardless of location.
 *
 * Also uses state to retroactively modify results for duplicate section names,
 * so that every section with a duplicate name is marked as an individual failure,
 * so that users get a full picture of which Sections they might need to change.
 */
export const noDuplicateSectionNamesRule = (section: Readonly<Section>, state: Record<string, any>) => {
  const uniqueSectionNames: Record<string, {
    count: number,
    results: ValidationResult["result"][]
  }> = state.uniqueSectionNames ??= {};

  let result = { passed: true };
  const titleString = section.title.en ?? '';
  const titleState = uniqueSectionNames[titleString];
  if (titleState) {
    titleState.count++;
    titleState.results.push(result);

    // Modify the current result and all prior results for this title
    titleState.results.forEach(r => {
      r.passed = false;
      r.message = `Section name "${titleString}" is used in ${titleState.count} Sections`;
    });

    return result;
  } else {
    state.uniqueSectionNames[titleString] = { count: 1, results: [result] };
    return result;
  }
}
